import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { PieChart } from "react-minimal-pie-chart";
import { root } from "./ProgressCircle.css.mjs";
const COLOUR_RED = "#D5292A";
const COLOUR_BLUE = "#3E8FE0";
const ProgressCircle = (props) => {
  const { percentage, children, warningType, onMouseOver, onMouseOut } = props;
  const balanceLeftPercentage = warningType === "NoWarning" ? percentage : 100;
  const fillColour = warningType === "NoWarning" ? COLOUR_BLUE : COLOUR_RED;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      position: "relative",
      className: root,
      role: "remaining-circle",
      onMouseEnter: onMouseOver,
      onMouseLeave: onMouseOut,
      borderRadius: "full",
      background: "surface",
      children: [
        /* @__PURE__ */ jsx(Box, { position: "absolute", width: "full", height: "full", children: /* @__PURE__ */ jsx(
          PieChart,
          {
            data: [{ value: balanceLeftPercentage, color: fillColour }],
            background: "#EAECF1",
            totalValue: 100,
            lineWidth: 14,
            startAngle: -90,
            lengthAngle: -360,
            animate: true
          }
        ) }),
        children && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            width: "full",
            height: "full",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children
          }
        )
      ]
    }
  );
};
export {
  ProgressCircle
};
